import { encryptPwd } from '@/hooks/usePwd'
import { http } from '../http'
import { URL } from './_constant'

/**
 * 个人信息-系统字典
 */
export function API_CENTER_DICTIONARY() {
  return http.post<ApiCenter.DictionaryRes>(URL.DICTIONARY)
}

/**
 * 个人信息-详情
 */
export function API_CENTER_INFO() {
  return http.post<ApiCenter.InfoRes>(URL.INFO)
}

/**
 * 个人信息-菜单
 */
// export function API_CENTER_MENUS(appid: string) {
//   return http.post<ApiCenter.MenusRes>(URL.MENUS, { appid })
// }

/**
 * 个人信息-菜单
 */
export async function API_CENTER_MENUS_ALL() {
  const res = await http.post<ApiCenter.MenusAllRes>(URL.MENUS_ALL)
  return res?.[0]?.menus ?? []
}

/**
 * 个人信息-编辑个人信息
 */
export function API_CENTER_EDIT_INFO(data) {
  return http.post(URL.EDIT_INFO, data)
}

/**
 * 个人信息-重置密码
 */
export function API_CENTER_RESET_PWD({ newPassWordConfirm, newPassWord, oldPassWord }: ApiCenter.ResetPwdReq) {
  return http.post(URL.RESET_PWD, {
    oldPassWord: encryptPwd(oldPassWord),
    newPassWordConfirm: encryptPwd(newPassWordConfirm),
    newPassWord: encryptPwd(newPassWord)
  })
}
/**
 * 个人信息-微信-解绑
 */
export function API_CENTER_WECHAT_UNBIND() {
  return http.post(URL.WECHAT_UNBIND)
}
/**
 * 个人信息-微信-绑定
 */
export function API_CENTER_WECHAT_BIND() {
  return http.post(URL.WECHAT_BIND)
}
/**
 * 个人信息-微信-绑定检查
 */
export function API_CENTER_WECHAT_BIND_CHECK() {
  return http.post(URL.WECHAT_BIND_CHECK)
}
/**
 * 个人信息-邮箱-绑定
 */
export function API_CENTER_EMAIL_BIND(data: ApiCenter.BindEmailReq) {
  return http.post(URL.EMAIL_BIND, data)
}
/**
 * 个人信息-手机号-绑定
 */
export function API_CENTER_PHONE_BIND(data: ApiCenter.BindPhoneReq) {
  return http.post(URL.PHONE_BIND, data)
}
